import React from 'react';

const skeletonCardClass =
  'rounded-3xl bg-white/5 border border-white/10 shadow-lg shadow-black/30 overflow-hidden';

export default function ContactListSkeleton() {
  return (
    <div className="grid gap-6 md:grid-cols-2">
      {Array.from({ length: 4 }).map((_, index) => (
        <div key={index} className={skeletonCardClass}>
          <div className="p-6 flex gap-4">
            <div className="h-16 w-16 rounded-2xl bg-white/10 animate-pulse" />
            <div className="flex-1 space-y-3">
              <div className="h-4 bg-white/10 rounded animate-pulse w-3/4" />
              <div className="h-4 bg-white/5 rounded animate-pulse w-1/2" />
              <div className="h-4 bg-white/5 rounded animate-pulse w-5/6" />
            </div>
          </div>
          <div className="px-6 pb-6 flex gap-3">
            <div className="h-9 bg-white/10 rounded-full animate-pulse flex-1" />
            <div className="h-9 bg-white/10 rounded-full animate-pulse flex-1" />
          </div>
        </div>
      ))}
    </div>
  );
}


